import React, { ComponentPropsWithoutRef } from "react";

import { useLabels } from "../../../hooks/useLabels";
import { DialogButton } from "../../dialog";
import { showDialogAsync } from "../../dialog-queue";
import { SimpleDialog } from "../../dialog/simple-dialog";
import { Modal } from "../../modal";
import { labels } from "./labels";

const UploadLimitDialog = ({
	limit,
	onOk,
	...modalProps
}: {
	limit: number;
	onOk: () => void;
} & ComponentPropsWithoutRef<typeof Modal>) => {
	const [[title, message, ok], areLabelsLoading] = useLabels([
		labels.title,
		labels.message,
		labels.close,
	]);

	const Footer = () => <DialogButton onClick={onOk}>{ok}</DialogButton>;

	return areLabelsLoading ? null : (
		<SimpleDialog title={title} footer={<Footer />} {...modalProps}>
			{eXpress.utils.formatString(message, limit.toString())}
		</SimpleDialog>
	);
};

export const showUploadLimitDialogAsync = (limit: number) => {
	return showDialogAsync(({ resolve }, { isOpen }) => (
		<UploadLimitDialog onOk={resolve} isOpen={isOpen} limit={limit} />
	));
};
